export const AUTH_TOKEN_NAME: string = 'jc-token';
export const GUEST_TOKEN_NAME: string = 'jc-guest-token';
export const PREV_GUEST_TOKEN_NAME: string = 'jc-prev-quest-token';
export const KIOSK_API_RECORD: string = 'service-api';
